import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '../modals/apiresponse';
import * as CryptoJS from 'crypto-js';
import { PersistenceService, StorageType } from 'angular-persistence';
import { localStorageInformationId, storeInformationId, systemConstants } from '../modals/common';
import { LoaderService } from './loader.service';
import { switchMap, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { LocalStorageService } from './localstorage.service';
import { AuditLogService } from './audit-log.service';


@Injectable({
  providedIn: 'root'
})

export class BaseService {
  key = CryptoJS.enc.Utf8.parse('wjmJIY2zScly1bctD26fDIN6nUJ4Qavn');
  iv = CryptoJS.enc.Utf8.parse('wjmJIY2zScly1bct');
  state;


  constructor(protected _http: HttpClient, private router: Router,
    // private store: Store<fromApp.AppState>,
    private persistanceService: PersistenceService, private loaderService: LoaderService,
    private localStorageService: LocalStorageService,
    private auditLogService: AuditLogService) {
  }

  getToken() {
    return document.cookie.split(';').filter(e => e.split('=')[0].trim() === 'UserDetailToken').map(e => e.split('=')[1])[0];
  }

  callSecureAPI(method: string, url: string, body?: any, param?: HttpParams) {
    this.loaderService.showLoader();

    const userdata = this.getLocalData(localStorageInformationId.userTokenInfo);
    let headers = new HttpHeaders({
      'AuthenticationKey': '2Pnx6EN78NlgnHlgc79aThYBJ7Zfl55/VF/rJps7ytM=',
      // 'OrgId': 'MySql',
      // 'Authorization': `bearer ${this.getLocalData(localStorageInformationId.tokenInformation)}`,
      'Authorization': `bearer ${this.getToken()}`,
    });

    // Set additional headers using setHeaderData()
    headers = this.setHeaderData('string', headers);

    // Set content-type if not already set in setHeaderData()
    if (!headers.has('content-type')) {
      headers = headers.set('content-type', 'application/json');
    }

    return this._http.request<ApiResponse>(
      new HttpRequest(method, systemConstants.domain + url, `${(JSON.stringify(body))}`,  //this.Encrypt
        { headers ,params:param })).pipe(
          tap( // Log the result or error
            data => {
              if (data.type === 4) {
                this.loaderService.hideLoader();
              }
            },
            error => { this.loaderService.hideLoader() }
          )
        );
  }

  // callSecureAPI(method: string, url: string, body?: any, loader: boolean = true): Observable<any> {
  //   if (loader) {
  //     this.loaderService.showLoader();
  //   }


  //   const userdata = this.getLocalData(localStorageInformationId.userTokenInfo);
  //   let headers = new HttpHeaders({
  //     'AuthenticationKey': 'Occucare@123',
  //     'OrgId': userdata.orgId.toString(),
  //     'Authorization': `bearer ${this.getToken()}`,
  //     'content-type': 'application/json'
  //   });
  
  //   // call to an api to check logged-in user's session
  //  // var http = this.callGetAPI('/Common/OrgId');

  //   return http.pipe(
  //     switchMap(res => {
  //       console.log(res);
  //       if (res > 0) {
  //         return this._http.request<ApiResponse>(
  //           new HttpRequest(method, systemConstants.domain + url, `"${this.Encrypt(JSON.stringify(body))}"`,
  //             { headers })).pipe(
  //               tap( // Log the result or error
  //                 data => {
  //                   if (data.type === 4) {
  //                     if (loader) {
  //                       this.loaderService.hideLoader();
  //                     }
  //                   }
  //                 },
  //                 error => {
  //                   if (error.status === 401) {
  //                     this.setLocalData('log', JSON.stringify(error));
  //                     window.location.href = systemConstants.webSiteUrl + '/Pages/Baseframework/Security/Login';
  //                   }
  //                   if (loader) {
  //                     this.loaderService.hideLoader();
  //                   }
  //                 }
  //               )
  //             );
  //       } else {
  //         // navigate to login if session expired
  //         var loginPageUrl = 'Pages/Baseframework/Security/Login';
  //         window.location.href = loginPageUrl;
  //       }
  //     })
  //   );
  // }

  callGetAPI<T>(url: string) {
    const userdata = this.getLocalData(localStorageInformationId.userTokenInfo);
    let headers = new HttpHeaders({
      'AuthenticationKey': '2Pnx6EN78NlgnHlgc79aThYBJ7Zfl55/VF/rJps7ytM=',
      'OrgId': userdata.orgId.toString(),
      'Authorization': `bearer ${this.getToken()}`,
      'content-type': 'application/json'
    });
    return this._http.get<T>(`${window.location.protocol}//${window.location.host}` + url, { headers });
  }

  callAPI(method: string, url: string, body?: any) {
    const headers = new HttpHeaders({
      'AuthenticationKey': '2Pnx6EN78NlgnHlgc79aThYBJ7Zfl55/VF/rJps7ytM=',
      'OrgId': '9999',
      'Authorization': `bearer ${this.getLocalData(localStorageInformationId.tokenInformation)}`,
      'content-type': 'undefined'
    });

    return this._http.request<ApiResponse>(
      new HttpRequest(method, systemConstants.webSiteUrl + url, body,
        { headers }));
  }

  callOpenAPI(method: string, url: string, body?: any) {
    const headers = new HttpHeaders({
      'AuthenticationKey': '2Pnx6EN78NlgnHlgc79aThYBJ7Zfl55/VF/rJps7ytM=',
      'OrgId': 'MySql'
    });
    return this._http.request(
      new HttpRequest(method, systemConstants.domain + url, body,
        { headers, responseType: 'text' })).pipe(
          tap( // Log the result or error
            data => {
              console.log(data);

            },
            error => { debugger; this.loaderService.hideLoader() }
          )
        );
    ;

  }

  getReposnse(res) {
    if (res['body'] !== '' && res['body'] !== undefined) {
      if (res['body']['data'] === 401) {
        // window.location.href = 'Pages/Baseframework/Security/Login';
      }
      if (res['body']['data'] != null && res['body']['data'] != '') {
        this.loaderService.hideLoader();
        return JSON.parse(this.Decrypt(res['body']['data']));
      }
      // this.loaderService.hideLoader();
    }
  }

  // getStoreInfo(type) {
  //   this.store.select(e => e[type]).subscribe((data) => this.state = data);;
  //   const token = this.state;
  //   return token[type];
  // }

  // setStoreInfo(type, info) {
  //   switch (type) {
  //     case 'tokenInformation':
  //       this.store.dispatch(new TokenInformationActions.AddTokenInformation(info));
  //       break;
  //     case 'loggedInUserInformation':
  //       this.store.dispatch(new LoggedInUserInformationActions.AddLoggedInUserInformation(info));
  //       break;
  //   }

  // }

  // getTokenInfo() {
  //   this.store.select(e => e.tokenInformation).subscribe((data) => this.state = data);;
  //   const token = this.state;
  //   return token['tokenInformation'];
  // }



  Encrypt(str) {
    const encrypted = CryptoJS.AES.encrypt(str, this.key, {
      iv: this.iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC
    });

    const result = CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
    return result;
  }

  Decrypt(str) {
    var decrypted = CryptoJS.AES.decrypt(str, this.key, { iv: this.iv });
    // console.log(decrypted.toString(CryptoJS.enc.Utf8));
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  setLocalData(id, info) {
    this.persistanceService.set(id, this.Encrypt(JSON.stringify(info)), { type: StorageType.LOCAL });
  }

  getLocalData(id) {
    const encryptedLocalData = this.persistanceService.get(id, StorageType.LOCAL);
    if (encryptedLocalData != '' && encryptedLocalData != undefined) {
      // console.log(this.Decrypt(encryptedLocalData));
      return JSON.parse(this.Decrypt(encryptedLocalData));
    }
  }

  // Date Methods

  calcDate(date1, date2) {
    var diff = Math.floor(date1.getTime() - date2.getTime());
    var day = 1000 * 60 * 60 * 24;

    var days = Math.floor(diff / day);
    var months = Math.floor(days / 31);
    var years = Math.floor(months / 12);

    var message = date2.toDateString();
    message += " was "
    message += days + " days "
    message += months + " months "
    message += years + " years ago \n"

    return { day: days, month: months, year: years };
  }

  setHeaderData(type: string, headers: HttpHeaders): HttpHeaders {
    let screenId: number = parseInt(this.localStorageService.getLocalData('taskId'));
    if (type === 'string')
      headers = headers.append('content-type', 'application/json');
    headers = headers.append('ScreenId', JSON.stringify(screenId));
    this.auditLogService.auditInformation$.subscribe(activityName => {
      if (activityName) {
        headers = headers.append('Activity', activityName);
      }
    });
    return headers;
  }
}